import React from 'react'
import "./CampaignCreatedModal.css"
import paymentSuccess from "../../../../assets/images/payment-successful.png"


const CampaignCreatedModal = () => {
  return (
    <div className='paymentModal scale-up-center'>
      <img src={paymentSuccess} />
      <h4>Your campaign has been <span>Created</span></h4>
      <p>You can view your ads under campaigns tab</p>
    </div>
  )
}

export default CampaignCreatedModal